import { motion } from "framer-motion";

// Section reveal variants
export const revealUp = {
  hidden: { opacity: 0, y: 48 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, ease: [0.22, 1, 0.36, 1] },
  },
};

export const staggerParent = {
  hidden: {},
  show: {
    transition: { staggerChildren: 0.08, delayChildren: 0.05 },
  },
};

// Masked line reveal — accepts an array of lines. Each line rides on a translateY inside an overflow-hidden mask.
export function MaskedLines({ lines, className = "", lineClass = "", delay = 0 }) {
  return (
    <span className={className} aria-label={lines.join(" ")}>
      {lines.map((line, i) => (
        <span
          key={i}
          className="block overflow-hidden pb-[0.08em]"
          style={{ perspective: 400 }}
          aria-hidden
        >
          <motion.span
            className={`block will-change-transform ${lineClass}`}
            initial={{ y: "110%", rotate: 4 }}
            animate={{ y: "0%", rotate: 0 }}
            transition={{
              duration: 1.05,
              ease: [0.22, 1, 0.36, 1],
              delay: delay + i * 0.11,
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

export function Reveal({ children, delay = 0, className = "", y = 32 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay }}
    >
      {children}
    </motion.div>
  );
}
